import type { SVGProps } from 'react'
const SvgSyTechSolidConfigurationManagement = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M5.76 8.64v3.88A8.16 8.16 0 0 0 12 20.29V5.73z" />
		<path
			fillOpacity={0.24}
			d="m12 20.29.66-.19a8.16 8.16 0 0 0 5.58-7.58V8.64L12 5.73zm5.79-16.15a3 3 0 0 0-.29 0l.83-1-.57-.48-1.67 2 2 1.66.48-.57-1-.85a2 2 0 0 1 .26 0 2.64 2.64 0 0 1 2.64 2.64 2.6 2.6 0 0 1-.29 1.19l.55.56.09-.13a3.5 3.5 0 0 0 .4-1.62 3.39 3.39 0 0 0-3.43-3.4"
		/>
		<path d="m5.67 17.7-.61.44.76 1.06a3 3 0 0 1-.27 0 2.64 2.64 0 0 1-1.33-4.29l-.39-.68a1 1 0 0 0-.11.11 3.38 3.38 0 0 0 1.65 5.58 3 3 0 0 0 .29.05l-1 .74.44.61 2.11-1.5z" />
	</svg>
)
export default SvgSyTechSolidConfigurationManagement
